module.exports = __webpack_public_path__ + "static/008291-65cf9ccbb63f2f9399983f57e0fdb4be.jpg";